// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1fe002d089844ca5","5405":"56ff751499e3e71a","8338":"12061f604ce57291"}[chunkId] + ".css";
};